import { useState } from '#imports'
import { computed, inject, onScopeDispose, provide, useId, watch, type ComputedRef, type Ref } from 'vue'
import { modalLayer, Z_INDEX, type ModalLayer } from '~/utils/zIndex'

const STACK_KEY = 'monorga-overlay-stack'
const POPPER_KEY = 'monorgaOverlayPopperZ'

function useStackIds(): Ref<string[]> {
  return useState<string[]>(STACK_KEY, () => [])
}

export function useOverlayStack(open: Ref<boolean>): ComputedRef<ModalLayer> {
  const ids = useStackIds()
  const id = useId()

  function release(): void {
    if (!ids.value.includes(id)) return
    ids.value = ids.value.filter((item) => item !== id)
  }

  watch(
    open,
    (isOpen) => {
      const present = ids.value.includes(id)
      if (isOpen && !present) ids.value = [...ids.value, id]
      if (!isOpen && present) release()
    },
    { immediate: true },
  )

  onScopeDispose(release)

  const layer = computed(() => {
    const index = ids.value.indexOf(id)
    return modalLayer(index < 0 ? 0 : index)
  })

  provide(POPPER_KEY, computed(() => layer.value.popper))
  return layer
}

export function useOverlayPopperZ(): ComputedRef<number> {
  const injected = inject<ComputedRef<number> | null>(POPPER_KEY, null)
  return computed(() => injected?.value ?? Z_INDEX.dropdown)
}
